export const BackendHost = '';
export const BackendPath = '/api';
